import type { FieldError as RHFFieldError } from "react-hook-form"

interface FieldErrorProps {
  error: RHFFieldError | undefined
}

export function FieldError({ error }: FieldErrorProps) {
  if (!error?.message) return null
  return <p className="text-2xs text-destructive mt-1">{error.message}</p>
}
